enum StatsDisplayType {
  DoubleColumn = "DoubleColumn",
  SingleColumn = "SingleColumn",
}

export default StatsDisplayType;
